export const SET_CLINIC_ID = 'SET_CLINIC_ID';
export const setClinicId = (id) => async (dispatch) => {
  dispatch({
    type: SET_CLINIC_ID,
    payload: {id},
  });
};
